<div class="flex justify-center h-full">
  <div class="flex flex-col justify-center w-full sm:w-3/4">
    <h2 class="text-4xl my-2 use-rhetorik-sans">Reset Password</h2>
    <form id="newPasswordForm" #newPasswordForm="ngForm" (ngSubmit)="onSubmit()" class="flex flex-col justify-center mt-2">

      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Email Address</mat-label>
        <input matInput type="text" name="Email" id="Email" required email [(ngModel)]="model.Email" #Email="ngModel">
        <mat-error>
          Please fill out this field
        </mat-error>
      </mat-form-field>

      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>Temporary Password</mat-label>
        <input matInput [type]="hide ? 'password' : 'text'" name="ExistingPassword" id="ExistingPassword" required [(ngModel)]="model.ExistingPassword" #ExistingPassword="ngModel">
        <button type="button" mat-icon-button matSuffix (click)="hide = !hide" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide">
        <mat-icon>{{hide ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error>
          Please fill out this field
        </mat-error>
      </mat-form-field>

      <mat-form-field color="primary" class="my-2" hideRequiredMarker="true">
        <mat-label>New Password</mat-label>
        <input matInput [type]="hide2 ? 'password' : 'text'" name="Password" id="Password" placeholder="New Password" required [(ngModel)]="model.Password" #Password="ngModel">
        <button type="button" mat-icon-button matSuffix (click)="hide2 = !hide2" [attr.aria-label]="'Hide password'" [attr.aria-pressed]="hide2">
        <mat-icon>{{hide2 ? 'visibility_off' : 'visibility'}}</mat-icon>
        </button>
        <mat-error>
          Please fill out this field
        </mat-error>
      </mat-form-field>

      <button mat-flat-button color="primary" type="submit" class="my-2" [disabled]="!newPasswordForm.form.valid">CHANGE PASSWORD</button>

    </form>
  </div>

</div>
